import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import bankService from '../services/bankService';

const BankAccountFormPage = () => {
  const [formData, setFormData] = useState({
    bank_name: '',
    branch_name: '',
    account_number: '',
    iban: '',
    currency: 'TL'
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await bankService.createAccount(formData);
      toast.success('Banka hesabı eklendi.');
      navigate('/banks');
    } catch (error) {
      toast.error(error.response?.data?.message || 'İşlem başarısız.');
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div className="card shadow-sm" style={{ maxWidth: '600px', margin: '0 auto' }}>
        <div className="card-header bg-white">
          <h4 className="mb-0">Yeni Banka Hesabı</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Banka Adı</label>
              <input type="text" name="bank_name" className="form-control" value={formData.bank_name} onChange={handleChange} required placeholder="Örn: Ziraat Bankası" />
            </div>
            <div className="mb-3">
              <label className="form-label">Şube Adı</label>
              <input type="text" name="branch_name" className="form-control" value={formData.branch_name} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">Hesap Numarası</label>
              <input type="text" name="account_number" className="form-control" value={formData.account_number} onChange={handleChange} />
            </div>
            <div className="mb-3">
              <label className="form-label">IBAN</label>
              <input type="text" name="iban" className="form-control" value={formData.iban} onChange={handleChange} required />
            </div>
            <div className="d-flex justify-content-end">
              <button type="button" onClick={() => navigate('/banks')} className="btn btn-secondary me-2">İptal</button>
              <button type="submit" className="btn btn-primary">Kaydet</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BankAccountFormPage;